import { render, staticRenderFns } from "./PaoYingChup.vue?vue&type=template&id=1096f7af&scoped=true&"
import script from "./PaoYingChup.vue?vue&type=script&lang=js&"
export * from "./PaoYingChup.vue?vue&type=script&lang=js&"
import style0 from "./PaoYingChup.vue?vue&type=style&index=0&id=1096f7af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1096f7af",
  null
  
)

export default component.exports